// "Make card from highlight" and "Cite this page": the only code for them in the main bundle. The
// sheets are a lazy chunk (app/make-card.js, __RVM.cardJs) with their own stylesheet, loaded on the
// first use.
//
// Cite this page reads only the tab's own state (title and address), so it is offered on any open
// website. Make card asks the page's engine frame for a selection, so it waits for secure tabs: it is
// offered only while this page runs its sites on the separate sandbox origin (tier A this load, and
// the tab's frame is the sandbox stand-in). With the separate origin off a page could already read
// the decks, so the feature stays off rather than pretend.
import { get } from "../shared/settings-store.js";
import { frames } from "./view.js";
import { remote } from "./proxy.js";
import { announce } from "./announce.js";
import { openInternal } from "./tabs.js";
import { metric } from "../shared/metric.js";

let cardUrl = __RVM.cardJs; // a let, so esbuild leaves the import alone
let cssUrl = __RVM.cardCss;
let loading = null, api = null;

const isPage = (t) => !!(t && !t.internal && !t.view && t.src && /^https?:\/\//i.test(String(t.url || "")));
export const citeOk = (t) => isPage(t);

// Secure tabs on for this student, right now, for this tab.
export function cardOk(t) {
	if (!isPage(t) || !remote()) return false;
	const f = frames.get(t.id);
	if (!f || f.rvRemote !== true || typeof f.selection !== "function") return false;
	try { return localStorage.getItem("rv:sbx-tier") === "A"; } catch { return false; }
}

const ctx = {
	allowed: cardOk,
	// Only the engine frame this tab owns is asked (the bridge accepts the answer only from the
	// engine host window on the sandbox origin, for this request's id and kind).
	ask: (t) => { const f = frames.get(t.id); return f && typeof f.selection === "function" ? f.selection() : Promise.resolve(null); },
	openInternal,
	announce,
	metric,
	incognito: (t) => get("incognito") === true || !!(t && t.priv),
};

function load() {
	if (loading) return loading;
	const css = document.createElement("link");
	css.rel = "stylesheet";
	css.href = cssUrl;
	const ready = new Promise((r) => { css.onload = css.onerror = r; });
	document.head.appendChild(css);
	loading = Promise.all([import(cardUrl), ready]).then(([m]) => { api = m.start(ctx); return api; }).catch(() => {
		loading = null; css.remove();
		announce("That didn't load. Check your connection and try again.");
		return null;
	});
	return loading;
}

// The menus offer these only when the checks above pass; they are checked again on the click.
export function makeCard(t, from) { if (cardOk(t)) open("makeCard", t, from); }
export function citePage(t, from) { if (citeOk(t)) open("citePage", t, from); }
function open(what, t, from) {
	const opener = from || document.activeElement;
	load().then((a) => a && a[what](t, opener));
}
